export enum UserType {
  Investor = 'Investor',
  Master = 'Master',
  Admin = 'Admin'
}

export enum OrderType {
  Open = 'Open',
  Closed = 'Closed'
}

export enum ServerType {
  MT4 = 0,
  MT5 = 1
}

export enum ServerTypeStr {
  MT4 = 'MT4',
  MT5 = 'MT5'
}

export enum FormatCategories {
  Short = 'Short',
  Long = 'Long'
}

export class Server {
  Guid = '';
  Name = '';
  Type = ServerType.MT4;
  TypeStr = 'MT4';
  FreeMarginCoef = 0;
  Enabled = true;
  StatusStr = '';
  DefaultMtGroup = '';
}

export enum BalanceOperationType {
  Connect = 'Connect',
  Disconnect = 'Disconnect',
  Deposit = 'Deposit',
  Withdraw = 'Withdraw',
  Performance = 'Performance',
  ManagementFee = 'ManagementFee',
  Commission = 'Commission',
  BalanceCorrection = 'BalanceCorrection',
  Swap = 'Swap',
  AnnualManagementFee = 'AnnualManagementFee',
  Charge = 'Charge'
}

export class PaginationInfo {
  TotalRecords = 0;
  TotalPages = 0;
  CurrentPage = 0;
  RecordsOnPage = 0;
}

export class BalanceOperation {
  MtOrderId = 0;
  Id = 0;
  Date = '';
  MasterId = 0;
  InvestorId = 0;
  Type = '';
  Amount = 0;
  Currency = 'USD';
  Comment = '';
}

export enum Language {
  EN = 'en',
  RU = 'ru'
}

export enum SummaryType {
  Deposits = 'deposits',
  Investments = 'investments',
  Profit = 'profit',
  Volumes = 'volumes',
  Investors = 'investors'
}

export class Summary {
  PeriodStartDate = '';
  PeriodEndDate = '';
  Value = 0;
}

export interface UserProfitAllTime {
  userId: number;
  profitFortnightAllTime: Array<Summary>;
}

export enum GraphSelection {
  OverallProfit = 'overall-profit',
  PeriodCumulative = 'profit',
  ProfitPerPeriod = 'profit-per-period',
  VolumePerPeriod = 'volume-per-period'
}

export enum GraphicsPeriodTypes {
  Day = 'Day',
  Week = 'Week',
  Fortnight = 'Fortnight',
  Month = 'Month',
  Year = 'Year',
  AllTime = 'singlePeriod'
}

export enum GraphicsPeriodTypesExt {
  Day = 'Day',
  Week = 'Week',
  Fortnight = 'Fortnight',
  Month = 'Month',
  Year = 'Year',
  All = 'All'
}

export enum AnnualManagementFeeMode {
  ByCurrentBalance = 'ByCurrentBalance',
  ByLastChargeBalance = 'ByLastChargeBalance'
}

export class IncentiveAccount {
  Login = 0;
  ServerName? = '';
  IncentiveFee: any = 0;
  ConnectionFee: any = 0;
  ManagementFee: any = 0;
  AnnualManagementFee: any = 0;
  PerLotFee: any = 0;
  PerDealFee: any = 0;
  Mode: any = AnnualManagementFeeMode.ByCurrentBalance;
  MtGroup?: string;
  CreateMtAccount?: boolean;
}

export enum PerLotDealFeeMode {
  PerLot = 'PerLot',
  PerDeal = 'PerDeal'
}

export class FeeAccountSet {
  [index: string]: any;

  Login = '';
  IncentiveFee = null;
  ConnectionFee = null;
  ManagementFee = null;
  AnnualManagementFee = null;
  AnnualManagementFeeMode = AnnualManagementFeeMode.ByCurrentBalance;
  PerLotDealFee = null;
  PerLotDealFeeMode = PerLotDealFeeMode.PerDeal;
  Valid = true;
  MtAccountCreationMode?: string;
  MtGroup?: string;
}

export class FeeAccountSetSeparatedDealLotFees {
  Login = 0;
  ServerName? = '';
  IncentiveFee: any = 0;
  ConnectionFee: any = 0;
  ManagementFee: any = 0;
  AnnualManagementFee: any = 0;
  PerLotFee: any = 0;
  PerDealFee: any = 0;
  Mode: any = AnnualManagementFeeMode.ByCurrentBalance;
  PerLotDealFeeMode: any = PerLotDealFeeMode.PerDeal;
}

export class ChangeAccountModeRequest {
  Mode = 0;
}

export enum OrderMode {
  Off = 'Off',
  Percent = 'Percent',
  Money = 'Money',
  FromMM = 'FromMM',
  Default = 'Default'
}

export enum CalcMethod {
  Regular = 'Regular',
  Running = 'running',
  RunningWithPreviousValue = 'RunningWithPreviousValue'
}

export enum ProfitMode {
  Money = 'Money',
  Percent = 'ReturnOnInvestment',
  ProfitabilityIndex = 'ProfitabilityIndex'
}

export enum AutoDisconnect {
  MaxLoss = 'MaxLoss',
  MaxProfit = 'MaxProfit'
}

export interface ItfbStorePopupModal {
  redirectButton: string;
  showTfbStorePopupModal: boolean;
}

export interface IFeedbackPopupModal {
  redirectButton: string;
  showPopup: boolean;
}

export interface ConfigFlags {
  hideRegisterButton: boolean;
  showMmRegistrator: boolean;
  // TODO PAMM-2341
  // showRequestTab: boolean;
  RequestTab: boolean;
  showOptionLockedWithdrawalsAndDisconnections: boolean;
  showMmInvestorCount: boolean;
}

export interface SharedConfig {
  CountCreditInAllocation: boolean;
  CountCreditInWithdrawal: boolean;
  CountCreditInRiskControl: boolean;
  RequestTab: boolean;
}

export type TotalTradeProfitType = 'Money' | 'ReturnOnInvestment' | 'ProfitabilityIndex';
export interface IframePage {
  customBackground: string;
  redirectConnectMoneyManagerURL: string;
  setGraphicsPeriodTypes: GraphicsPeriodTypes;
  setSpecificDate: string;
  hideNegativeProfitMasters: boolean;
  limit: string;
  totalTradeProfitType: TotalTradeProfitType;
}

export enum BalanceOperationTypesMasters {
  Connect = 'Connect',
  Disconnect = 'Disconnect',
  Deposit = 'Deposit',
  Withdraw = 'Withdraw',
  Performance = 'Performance',
  ConnectionFee = 'ConnectionFee',
  ManagementFee = 'ManagementFee',
  AnnualManagementFee = 'AnnualManagementFee',
  Commission = 'Commission',
  DealCommission = 'DealCommission',
  DealTax = 'DealTax',
  Swap = 'Swap',
  BalanceCorrection = 'BalanceCorrection',
  Credit = 'Credit',
  ProfitCorrection = 'Profit Correction',
  CreditCorrection = 'Credit Correction',
  CreditConnect = 'Credit Connect',
  CreditDisconnect = 'Credit Disconnect',
  Charge = 'Charge'
}

export enum BalanceOperationTypesInvestors {
  Deposit = 'Deposit',
  Withdraw = 'Withdraw',
  Performance = 'Performance',
  ConnectionFee = 'ConnectionFee',
  ManagementFee = 'ManagementFee',
  AnnualManagementFee = 'AnnualManagementFee',
  Commission = 'Commission',
  DealCommission = 'DealCommission',
  DealTax = 'DealTax',
  Swap = 'Swap',
  BalanceCorrection = 'BalanceCorrection',
  Credit = 'Credit',
  ProfitCorrection = 'Profit Correction',
  CreditCorrection = 'Credit Correction',
  Charge = 'Charge'
}

export enum MtAccountCreationMode {
  Link,
  SpecifiedMtLogin,
  NewMtLogin
}

export enum PopupStatus {
  Open = 'Open',
  Closed = 'Closed'
}

export enum ActivePage {
  ClosedOrders = 'closed-orders',
  BalanceOperations = 'balance-operations'
}
